import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Button from 'material-ui/Button';
import classNames from 'classnames';
import { TimelineIconType, TimelineStatusLabelType } from "../../../constants/ComponentTypes";
import MoreVertIcon from "material-ui-icons/MoreVert";
import DropdownMenu from "../../common/DropdownMenu";
import { connect } from 'react-redux';
import { deleteTimelineStatusById } from '../../../redux/actions/Timeline';

const styles = () => ({
  root: {
    display: "flex",
    alignItems: "flex-end",
    minWidth: "120px",
    flexDirection: "column",
    marginLeft: "40px",
  },

  btn: {
    padding: '10px 18px',
    height: "33px",
    width: "100px",
    borderRadius: "2px",
    fontSize: "13px",
  },

  btnLetterOrderEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: '#FFFFFF',
    },
  },

  btnFollowCallEnable: {
    border: "1px solid #1A65FF",
    background: "#1A65FF",
    color: "#FFFFFF",
    "&:hover": {
      background: "#FFFFFF",
      color: '#1A65FF',
    },
  },

  iconButton: {
    color: "#71737B",
    padding: 0,
    width: "32px",
    minWidth: "32px",
  },

  btnOpened: {
    color: "rgb(26, 101, 255)",
  },

  dropdown: {
    minWidth: "180px",
    margin: "12px 0 12px 12px",
  },
});

class Function extends React.Component {
  handleDeleteStatus = (id) => {
    if (window.confirm("ステータスを削除します。よろしいですか？")) {
      this.props.deleteTimelineStatusById(id);
    }
  }

  render() {
    const { classes, status } = this.props;
    const statusUserType = status.type;

    if (statusUserType === TimelineIconType.SYS_STATUS &&
      status &&
      status.letter_order_address &&
      status.letter_order_address.letter_order &&
      status.letter_order_address.letter_order.order
    ) {
      if (status.status_label_type === TimelineStatusLabelType.QR_CODE_REACTION) {
        let menu = [
          { name: "注文詳細", func: () => this.props.toggleLetterOrderDetailDialog(status) },
          { name: "削除", func: () => this.handleDeleteStatus(status.id) },
        ];
        return (
          <DropdownMenu
            menuItems={menu}
            classes={{
              btn: classes.iconButton,
              btnOpened: classes.btnOpened,
              dropdown: classes.dropdown,
            }}
            popperPlacement="bottom-end"
          >
            <MoreVertIcon />
          </DropdownMenu>
        );
      } else {
        return (
          <div className={classes.root}>
            <Button className={classNames(classes.btn, classes.btnLetterOrderEnable)} onClick={() => this.props.toggleLetterOrderDetailDialog(status)}>
              注文詳細
            </Button>
          </div>
        );
      }
    } else if (statusUserType === TimelineIconType.USER_STATUS) {
      let menu = [
        { name: "編集", func: () => this.props.toggleEditStatusDialog(status, this.props.hasFollowCallOrderAddress) },
        { name: "削除", func: () => this.handleDeleteStatus(status.id) },
      ];
      return (
        <DropdownMenu
          menuItems={menu}
          classes={{
            btn: classes.iconButton,
            btnOpened: classes.btnOpened,
            dropdown: classes.dropdown,
          }}
          popperPlacement="bottom-end"
        >
          <MoreVertIcon />
        </DropdownMenu>
      )
    } else if (statusUserType === TimelineIconType.FOLLOW_CALL_USER_STATUS || statusUserType === TimelineIconType.RESEARCHER_USER_STATUS) {
      return (
        <Button className={classNames(classes.btn, classes.btnFollowCallEnable)} onClick={() => this.props.toggleFollowCallDetailDialog(status)}>
          詳細確認
        </Button>
      )
    } else {
      return null;
    }
  }
}

Function.propTypes = {
  classes: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  hasFollowCallOrderAddress: PropTypes.bool.isRequired,
  toggleEditStatusDialog: PropTypes.func.isRequired,
  toggleLetterOrderDetailDialog: PropTypes.func.isRequired,
  toggleFollowCallDetailDialog: PropTypes.func.isRequired,
  deleteTimelineStatusById: PropTypes.func.isRequired,
};

const mapStateToProps = () => {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return {
    // タイムラインを削除
    deleteTimelineStatusById(id) {
      dispatch(deleteTimelineStatusById(id));
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(Function));



// WEBPACK FOOTER //
// ./src/components/Timeline/parts/Function.jsx